export default {
    sourceType: 'module',
    plugins: ['objectRestSpread','jsx']
};



// WEBPACK FOOTER //
// ./src/builder/astParserConfig.js